module.exports = __webpack_public_path__ + "static/media/tickWhite.049ce2a3.svg";